import appConfigs from 'appConfigs';

export const getIcon = (fileName: string): string =>
  `/${appConfigs.assets.icons}/${fileName}`;
export const getImage = (fileName: string): string =>
  `/${appConfigs.assets.images}/${fileName}`;
